import { TabsProps } from 'components/core/Tabs/Tabs.types';
import { Styled } from './';
import React from 'react';
import ReactTooltip from 'react-tooltip';

const Tabs = ({ tabHeaders, onClickHandler }: TabsProps) => {
  return (
    <Styled.TabsWrapper>
      <Styled.TabsHeader>
        {tabHeaders.map((tab, index) => (
          <React.Fragment key={tab.name}>
            <Styled.TabsHeaderBody
              selectedTab={tab.isVisible}
              data-index={index}
              data-tip={tab.tooltip}
              data-for={tab.name}
              onClick={() => {
                onClickHandler(tab.key);
              }}
            >
              {tab.name}
            </Styled.TabsHeaderBody>
            <ReactTooltip id={tab.name} place="top" effect="solid" />
          </React.Fragment>
        ))}
      </Styled.TabsHeader>
    </Styled.TabsWrapper>
  );
};

export default Tabs;
